import { Typography } from 'src/components';
import { formatDayAbbr } from 'src/utils/formatDayAbbr/formatDayAbbr';

interface ScheduleProps {
  schedule: { [key: string]: { [key: string]: number } };
}

const bgColorByPercentage = (input: number | string): string => {
  if (typeof input === 'number') {
    if (input === 0) {
      return 'bg-slate-200';
    } else if (input >= 1 && input <= 20) {
      return 'bg-green-100';
    } else if (input >= 21 && input <= 40) {
      return 'bg-green-500';
    } else if (input >= 41 && input <= 60) {
      return 'bg-green-700';
    } else if (input >= 61) {
      return 'bg-green-800';
    }
  } else {
    return 'bg-[#C7F7C7]';
  }
};

const textColorByPercentage = (input: number | string): string => {
  if (typeof input === 'number') {
    if (input === 0) {
      return 'text-disabled';
    } else if (input >= 1 && input <= 20) {
      return 'text-green-800';
    } else if (input >= 21 && input <= 40) {
      return 'text-green-100';
    } else if (input >= 41 && input <= 60) {
      return 'text-green-200';
    } else if (input >= 61) {
      return 'text-green-100';
    }
  } else {
    return 'text-green-500';
  }
};

const Schedule = ({ schedule }: ScheduleProps) => {
  return (
    <div className="bg-[#F0F4F8] p-4 pb-2">
      <div>
        <div className="flex items-center gap-2">
          <Typography variant="h6" className="font-semibold pb-1">
            Visit Planner
          </Typography>
        </div>
        <Typography variant="caption" className="text-[#555E68]">
          Choose the best days to visit this location based on physician
          activity.
        </Typography>
        <div className="grid grid-cols-7 gap-4 mt-2">
          {Object.entries(schedule).map(([day]) => {
            const formattedDay = formatDayAbbr(day);
            const percentageValue =
              schedule[day].percentage ?? schedule[day].claims;
            const formattedPercentage =
              typeof percentageValue === 'number'
                ? `${percentageValue}%`
                : percentageValue;
            return (
              <div key={`${percentageValue}-${formattedDay}`}>
                <div className="flex flex-col items-center p-0">
                  <div
                    className={`flex justify-center w-full max-w-16 py-1 rounded-lg ${bgColorByPercentage(
                      percentageValue
                    )}`}
                  >
                    <p className={textColorByPercentage(percentageValue)}>
                      {formattedDay}
                    </p>
                  </div>
                  <Typography variant="body2" className="py-2 text-[#292B33]">
                    {formattedPercentage}
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Schedule;
